// @flow
import React from 'react'

const Laptop = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="19" viewBox="0 0 23 19">
      <g fill="none" fillRule="evenodd">
        <path d="M-1-3h24v24H-1z" />
        <g stroke="#6E7B8C" strokeLinecap="square">
          <path d="M19.5 11.5v-10a1 1 0 0 0-1-1h-14a1 1 0 0 0-1 1v10M19.5 11.5h-16l-2.403 5.606a1 1 0 0 0 .92 1.394h18.967a1 1 0 0 0 .919-1.394L19.5 11.5z" />
        </g>
      </g>
    </svg>
  )
}

export default Laptop



// WEBPACK FOOTER //
// ./src/components/Icons/Laptop.js